import { http } from '@Techedge/digitalportal-shared'
import qs from 'qs'

export class ProfileService {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static PROFILE_URL: string = ProfileService.BASE_URL + `/profileapi`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static GetSearchUserList = (value: string) => {
        return http.get<any>(
            `${ProfileService.PROFILE_URL}/profilemanagement/user/search?userId=${value}`,
            ProfileService.headersObj
        )
    }
    static GetUserAvatars = (userIds: string[]) => {
        return http.put<any>(
            `${ProfileService.PROFILE_URL}/user/profile/avatars`,
            { userIds },
            ProfileService.headersObj
        )
    }

    static GetActivityBadges = (storeIds: string[], projectType: string) => {
        return http.get<any>(`${ProfileService.PROFILE_URL}/profile/activity/badges`, {
            ...ProfileService.headersObj,
            params: { storeIds, projectType },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
        })
    }
}
